export enum ResourcePermission {
  NoAccess = "no_access",
  Manager = "manager",
  EditAndPublish = "edit_and_publish",
}

export type AssignableResourcePermission = Exclude<ResourcePermission, ResourcePermission.NoAccess>;
